import React from 'react';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CenteredFlexBox } from '../../../../Components/FlexBox';
import { formatThousands } from '../../../../Utils/constants/general';
import {
  CALL_DETAILS_GRID,
  CALL_DETAILS_COLUMN_GAP,
  callDetailsValueSx,
} from './SectionCallDetailsPaper';

const SectionCountersPaper = function SectionCountersPaper({
  counters = [],
  onClick,
  selected,
}) {
  return (
    <Paper
      sx={{
        padding: '20px',
        cursor: onClick ? 'pointer' : 'default',
        outline: selected
          ? (theme) => `2px solid ${theme.palette.primary.main}`
          : 'none',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: CALL_DETAILS_GRID,
          alignItems: 'center',
          columnGap: CALL_DETAILS_COLUMN_GAP,
          rowGap: '20px',
        }}
      >
        {counters.map(({ icon, label, value, tooltip }, index) => (
          <React.Fragment key={index}>
            <CenteredFlexBox gap="16px" minWidth={0}>
              {icon}
              <Typography
                variant="body1"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {label}
              </Typography>
              {tooltip && (
                <Tooltip title={tooltip} arrow placement="top">
                  <InfoOutlinedIcon
                    sx={{
                      fontSize: '1.1rem',
                      color: '#90a4ae',
                      cursor: 'help',
                    }}
                  />
                </Tooltip>
              )}
            </CenteredFlexBox>
            <Box />
            <Box />
            <Typography sx={callDetailsValueSx}>
              {formatThousands(value)}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    </Paper>
  );
};

export default SectionCountersPaper;
